/* snapshots.icon.svg.js */

module.exports = {
    icon: `    
            <svg viewBox="0 0 19 16" preserveAspectRatio="none">
            <g>
                <path class="foreground-gl" d="M1.6,11.6L0,4.9c-0.1-0.6,0.5-1,1-0.6l1.8,1.5C3,5.9,3.2,6,3.4,5.9l2.2-0.8C6.2,4.9,6.7,5.5,6.4,6l-3.6,5.9
                    C2.4,12.3,1.7,12.2,1.6,11.6z"/>
            </g>
            <path class="foreground-gl" d="M12.6,3.3c2,1.7,2.5,4.6,1.3,6.8H16c1-2.8,0.3-6.1-2.1-8.2C10.7-0.9,5.8-0.6,3,2.5c-0.4,0.4-0.3,1,0.1,1.3
                c0.4,0.3,1,0.3,1.4-0.1C6.5,1.5,10.2,1.2,12.6,3.3z"/>
            <path class="foreground-gl" d="M13.6,12.3c-0.4,0-0.5,0.6-0.5,1.1c0,0.5,0.1,1.1,0.5,1.1c0.4,0,0.5-0.6,0.5-1.1C14.1,12.9,13.9,12.3,13.6,12.3
                z"/>
            <path class="foreground-gl" d="M10.2,12.3c-0.4,0-0.5,0.6-0.5,1.1c0,0.5,0.1,1.1,0.5,1.1c0.4,0,0.5-0.6,0.5-1.1C10.8,12.9,10.6,12.3,10.2,12.3
                z"/>
            <path class="foreground-gl" d="M15.9,12.3c-0.4,0-0.5,0.6-0.5,1.1c0,0.5,0.1,1.1,0.5,1.1c0.4,0,0.5-0.6,0.5-1.1C16.4,12.9,16.2,12.3,15.9,12.3
                z"/>
            <path class="foreground-gl" d="M5,11.1V16h14v-4.9H5z M8,15c-0.6,0-1-0.7-1-1.5c0-0.8,0.4-1.5,1-1.5c0.6,0,1,0.7,1,1.5C9,14.3,8.6,15,8,15z
                 M10.2,15c-0.6,0-1-0.7-1-1.5c0-0.8,0.4-1.5,1-1.5c0.6,0,1,0.7,1,1.5C11.3,14.3,10.9,15,10.2,15z M12.2,14.7c0,0.1,0,0.2-0.2,0.2
                h-0.2c-0.1,0-0.2,0-0.2-0.2v-0.2c0-0.1,0-0.2,0.2-0.2H12c0.2,0,0.2,0,0.2,0.2V14.7z M12.2,13.2c0,0.1,0,0.2-0.2,0.2h-0.2
                c-0.1,0-0.2,0-0.2-0.2V13c0-0.1,0-0.2,0.2-0.2H12c0.2,0,0.2,0,0.2,0.2V13.2z M13.6,15c-0.6,0-1-0.7-1-1.5c0-0.8,0.4-1.5,1-1.5
                c0.6,0,1,0.7,1,1.5C14.6,14.3,14.2,15,13.6,15z M15.9,15c-0.6,0-1-0.7-1-1.5c0-0.8,0.4-1.5,1-1.5c0.6,0,1,0.7,1,1.5
                C16.9,14.3,16.5,15,15.9,15z"/>
            <path class="foreground-gl" d="M8,12.3c-0.4,0-0.5,0.6-0.5,1.1c0,0.5,0.1,1.1,0.5,1.1c0.4,0,0.5-0.6,0.5-1.1C8.5,12.9,8.3,12.3,8,12.3z"/>
            </svg>
         `
};
